import { get, set } from 'lodash';

import { TOKEN_START, TOKEN_FINISH, REMOVE_LOGO } from './actions';

const initialState = {
  step: 0,
  loadErrors: null,
  initialValues: {},
  profile: {},
  setupErrors: null,
  updateErrors: null,
  gettingToken: false,
  asJson: null
};

export default (state = {}, action) => {
  let newState = Object.assign({}, initialState, state);

  switch (action.type) {
    case TOKEN_START:
      newState.gettingToken = true;
      break;
    case TOKEN_FINISH:
      newState.gettingToken = false;
      break;
    case REMOVE_LOGO:
      let logo = get(newState.initialValues, 'meta_datas.logo');
      if (logo) {
        newState.initialValues = set(
          newState.initialValues,
          'meta_datas.logo.value',
          null
        );
        newState.profile = newState.initialValues;
        newState.asJson = JSON.stringify(newState.initialValues);
      }
      break;
    default:
      break;
  }

  return newState;
};



// WEBPACK FOOTER //
// ./src/components/app/account-setup/reducer.js